import { atom } from "recoil";

const toggleAtom = atom({
    key: "toggle",
    default: "b2c"

});

export default toggleAtom;